// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "-" + {"88":"df55b752334be01e7e4d","243":"307c1cf31df043fbcfea","615":"c797de0dfbb0385b492c","682":"010d3484390bfdcb1778","688":"dc0d4402b07a4e80823c","852":"3f533ce2546315169381","951":"e112a1540854a300343e"}[chunkId] + ".bundle.js";
};